import React from "react";

// 🧩 Importar íconos locales desde src/assets
import javaIcon from "../../assets/icons/png/java.png";
import reactIcon from "../../assets/icons/png/react.png";
import typescriptIcon from "../../assets/icons/png/typescript.png";
import reduxIcon from "../../assets/icons/png/redux.png";
import postgresqlIcon from "../../assets/icons/png/postgresql.png";
import awsIcon from "../../assets/icons/png/aws.png";
import springbootIcon from "../../assets/icons/png/springboot.png";
import jwtIcon from "../../assets/icons/png/jwt.png";
import axiosIcon from "../../assets/icons/png/axios.png";
import viteIcon from "../../assets/icons/png/vite.png";
import kafkaIcon from "../../assets/icons/png/kafka.png";
import dockerIcon from "../../assets/icons/png/docker.png";

interface Technology {
  name: string;
  icon: string;
}

const technologies: Technology[] = [
  { name: "Java", icon: javaIcon },
  { name: "Spring Boot", icon: springbootIcon },
  { name: "React", icon: reactIcon },
  { name: "TypeScript", icon: typescriptIcon },
  { name: "Redux", icon: reduxIcon },
  { name: "PostgreSQL", icon: postgresqlIcon },
  { name: "AWS Cloud", icon: awsIcon },
  { name: "Apache Kafka", icon: kafkaIcon },
  { name: "JWT Auth", icon: jwtIcon },
  { name: "Axios", icon: axiosIcon },
  { name: "Vite", icon: viteIcon },
  { name: "Docker", icon: dockerIcon },
];

const TechnologiesGrid: React.FC = () => {
  return (
    <div className="mt-10">
      <h5 className="mb-8 text-lg font-semibold text-gray-800 dark:text-gray-200">
        Tecnologías Utilizadas
      </h5>

      <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6">
        {technologies.map((tech) => (
          <div
            key={tech.name}
            className="flex flex-col items-center justify-center gap-4 rounded-2xl border border-stroke bg-white p-7 shadow-md
                       transition-all duration-200 hover:scale-105 hover:shadow-xl dark:border-strokedark dark:bg-boxdark"
          >
            <div className="flex items-center justify-center h-20 w-20">
              <img
                src={tech.icon}
                alt={tech.name}
                className="h-20 w-20 object-contain"
              />
            </div>
            <p className="text-sm font-semibold text-gray-800 dark:text-gray-300 text-center tracking-wide">
              {tech.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnologiesGrid;
